import React, { useEffect, useState } from 'react';
import axios from 'axios';
import API_BASE_URL from '../../../services/api';
import { Button } from '../../../components/ui/button';
import { Input } from '../../../components/ui/input';

const API = `${API_BASE_URL}/api`;

const MediaPicker = ({ open, onClose, onSelect, mediaType = 'gallery_image' }) => {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open) fetchItems();
    // eslint-disable-next-line
  }, [open]);

  const fetchItems = async () => {
    try {
      setLoading(true);
      const params = new URLSearchParams();
      params.append('media_type', mediaType);
      if (q) params.append('q', q);
      params.append('limit', '60');
      const res = await axios.get(`${API}/media/items/admin?${params.toString()}`, { withCredentials: true });
      setItems(res.data || []);
    } catch (e) {
      // silent
    } finally {
      setLoading(false);
    }
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-40 bg-black/50 flex items-center justify-center">
      <div className="bg-card rounded-lg w-[90vw] max-w-5xl p-4">
        <div className="flex items-center justify-between mb-3">
          <div className="font-semibold">Sélectionner un média</div>
          <Button variant="outline" onClick={onClose}>Fermer</Button>
        </div>
        <div className="flex gap-2 mb-3">
          <Input placeholder="Rechercher..." value={q} onChange={e => setQ(e.target.value)} onKeyDown={e => { if (e.key === 'Enter') fetchItems(); }} />
          <Button variant="outline" onClick={fetchItems}>Rechercher</Button>
        </div>
        {loading ? (
          <div className="text-center py-8 text-muted-foreground">Chargement…</div>
        ) : (
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3 max-h-[60vh] overflow-auto">
            {items.map(it => (
              <button key={it.id} className="border rounded hover:border-primary overflow-hidden" onClick={() => { if (onSelect) onSelect(it.image_url || it.video_url || it.document_url); onClose(); }}>
                {it.image_url ? (
                  <img src={it.image_url} alt={it.title} className="w-full h-28 object-cover" />
                ) : (
                  <div className="h-28 flex items-center justify-center text-xs text-muted-foreground">{it.title || it.id}</div>
                )}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default MediaPicker;